export const USER_ROLES = {
  SUPER_ADMIN: "super_admin",
  PLATFORM_ADMIN: "platform_admin",
  ORGANIZATION_ADMIN: "organization_admin",
  LEAGUE_ADMIN: "league_admin",
};

// Roles the backend treats as match admins (backend ADMIN_ROLES in
// controllers/match/matchController.js). Keep the two lists in sync.
export const MATCH_ADMIN_ROLES = [
  USER_ROLES.SUPER_ADMIN,
  USER_ROLES.PLATFORM_ADMIN,
  USER_ROLES.ORGANIZATION_ADMIN,
  USER_ROLES.LEAGUE_ADMIN,
];

export const USER_ROLE_ALIASES = {
  superadmin: USER_ROLES.SUPER_ADMIN,
};

export const normalizeUserRole = (role) => {
  if (!role) return role;
  return USER_ROLE_ALIASES[role] || role;
};

export const TEAM_MEMBER_ROLES = {
  OWNER: "owner",
  CREATOR: "creator",
  ADMIN: "admin",
  MANAGER: "manager",
  COACH: "coach",
  MEMBER: "member",
  PLAYER: "player",
  CAPTAIN: "captain",
  SCORER: "scorer",
};

export const TEAM_MEMBER_ADMIN_ROLES = [
  TEAM_MEMBER_ROLES.OWNER,
  TEAM_MEMBER_ROLES.CREATOR,
  TEAM_MEMBER_ROLES.ADMIN,
  TEAM_MEMBER_ROLES.MANAGER,
  TEAM_MEMBER_ROLES.COACH,
];

export const TEAM_MEMBER_ROLE_PRIORITY = {
  [TEAM_MEMBER_ROLES.OWNER]: 1,
  [TEAM_MEMBER_ROLES.CREATOR]: 1,
  [TEAM_MEMBER_ROLES.ADMIN]: 2,
  [TEAM_MEMBER_ROLES.MANAGER]: 3,
  [TEAM_MEMBER_ROLES.COACH]: 4,
  [TEAM_MEMBER_ROLES.MEMBER]: 5,
};
